import { FileIcon } from "components/design/FileIcon";
import { Preview } from "components/PreviewModal";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useModal } from "hooks/useModal";
import { useMultipleFileDetails } from "hooks/useMultipleFileDetails";

type LinkedDocFieldProps = {
  value: string;
  docLabel: string;
  fileIds: string[];
};

export const LinkedDocField = ({
  value,
  docLabel,
  fileIds,
}: LinkedDocFieldProps) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const files = useMultipleFileDetails(fileIds);
  const previewModal = useModal();

  const file = files[0];

  if (!file) {
    return <span className="t-text-body t-text-text-100">{value}</span>;
  }

  return (
    <>
      <span className="t-group t-flex t-items-center t-gap-1.5 t-text-body t-text-text-100">
        {value}
        <button
          type="button"
          onClick={previewModal.open}
          aria-label={`View ${docLabel}`}
          className="all:unset t-flex t-shrink-0 t-cursor-pointer t-opacity-0 t-transition-opacity group-hover:t-opacity-100"
        >
          <FileIcon fileType={file.file_type} size="18" />
        </button>
      </span>

      <Preview
        showModal={previewModal.isOpen}
        closeModal={previewModal.close}
        groupId={groupId}
        previewId={file.uuid}
      />
    </>
  );
};
